export default {
      id: "tapered_bull-usage",
      viewBox: "0 0 21 30",
      url: __webpack_public_path__ + "icons.svg#tapered_bull",
      toString: function () {
        return this.url;
      }
    }